import { API, Auth } from 'aws-amplify';

export const graphql = async (operation) => {
  const token = (await Auth.currentSession()).idToken.jwtToken;
  return API.graphql(operation, {
    Authorization: token,
  });
};

export const NOOP = 'VALUE';
